enum FieldTypes {
  BOOLEAN = 'boolean',
  SELECT_VALUE = 'select-value',
  MULTI_SELECT_VALUE = 'multi-select-value',
  SELECT_RELATION = 'select-relation',
  MULTI_SELECT_RELATION = 'multi-select-relation',
  INTEGER = 'integer',
  DECIMAL = 'decimal',
  TEXT = 'text',
  FILE = 'file',
  FILES = 'files',
  READ_ONLY = 'read-only',
  JSON_AGG = 'json-agg',
  OBJECT = 'object',
  DATE = 'date',
  DATE_TIME = 'date-time',
}

export default FieldTypes;
